import { render } from "./index.vue?vue&type=template&id=f3958d3c"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/design/components/molecules/rich-text-editor/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f3958d3c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f3958d3c', __exports__)) {
    api.reload('f3958d3c', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=f3958d3c", () => {
    api.rerender('f3958d3c', render)
  })

}


export default __exports__